module.exports = __webpack_public_path__ + "static/img/18.8778a49.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/18.jpeg
// module id = cvZG
// module chunks = 0